// External libraries
import $beaver from 'beaver-logger';

// Internal modules
import { getLocale } from '../globals';
import { LOG_PREFIX } from '../constants';
import { COMMON_PAYLOAD, PAGE_LOAD_PAYLOAD, STATE_NAME } from './fptiPayloads';

const initFpti = ({ token, mode = 'signup' }) => {
  COMMON_PAYLOAD.context_id = token;
  COMMON_PAYLOAD.buyer_type = mode !== 'signup' ? 'GuestUser' : 'NewUser';

  const payload = {
    api_integration_type: 'standard',
    app_int_type: '', // BROWSER or WebView
    design: 'full context',
    experience: 'onboarding_lite',
    integration_type: 'EC',
    market: 'MERCHANT',
    planning_activity_handle: '',
    state_name: STATE_NAME.init,
    transition_name: 'prepare_billing_page_init',
  };

  fpti('INIT', payload);
};

const fpti = (event, payload, immediateFlush) => {
  // Tack on common payload, required for every FPTI event,
  // and the current timestamp
  Object.assign(payload, COMMON_PAYLOAD, {
    server_epoch_timestamp: Date.now(),
  });

  // log to CAL for debugging
  const { country, locale } = getLocale();
  const action = LOG_PREFIX.test(event)
    ? `${event.toUpperCase()}_FPTI`
    : `WEASLEY_${event.toUpperCase()}_FPTI`;

  $beaver.info(action, {
    clientCountry: country,
    clientLocale: locale,
    ...payload,
  });

  // fire off an FPTI event
  $beaver.track(payload);

  if (immediateFlush) {
    $beaver.flush();
  }
};

const fptiTrackPageLoad = {
  handleItemLoaded(name) {
    this.items.delete(name);

    if (!this.items.size) {
      const payload = PAGE_LOAD_PAYLOAD(true);
      fpti('weasley_page_loaded', payload);
    }
  },
  items: new Set(),
  registerItem(name) {
    this.items.add(name);
  },
};

export { fpti, fptiTrackPageLoad, initFpti };
